module.exports = __webpack_public_path__ + "img/block_1.d193577d.webp";